import React from 'react';
import { TaxCard as TaxCardStyled, TaxTitle, TaxValue, TaxInfo } from './styles';
import { formatCurrency } from '../../services/pagamentoService';

const TaxCardComponent = ({ valor, pedidoName }) => (
  <TaxCardStyled>
    <TaxTitle>Taxa de {pedidoName}</TaxTitle>
    <TaxValue>
      {formatCurrency(valor)}
      <small> (taxa única)</small>
    </TaxValue>
    <TaxInfo>O pagamento é necessário para efetivar sua solicitação</TaxInfo>
  </TaxCardStyled>
);

export default TaxCardComponent;